import React from 'react';

import { SkeletonContainer } from './styles';

const AspectRatioLoading: React.FC = () => {
  return <SkeletonContainer />;
};

export default AspectRatioLoading;
